import { useDyteMeeting } from '@dytesdk/react-web-core';
import { DyteMeeting } from '@dytesdk/react-ui-kit';

const JoinConfirmation = () => {
	const dyteMeeting = useDyteMeeting();

	return (
		<div
			data-testid="dyte-join-confirmation-screen"
			className="flex h-full w-full items-center justify-center dark:text-white "
		>
			<div style={{ height: '100%', width: '100vw' }}>
				<DyteMeeting className="bg-inherit" meeting={dyteMeeting.meeting} />
			</div>
		</div>
	);
};

export default JoinConfirmation;
